import React, { useState } from 'react';
import RegisterModal from './RegisterModal';

const Header = () => {
    const [expanded, setExpanded] = useState(false);
    const [showModal, setShowModal] = useState(false);

    const handleShow = () => setShowModal(true);
    const handleClose = () => setShowModal(false);

    const closeNavbar = () => {
        setExpanded(false);
    };

return (
    <nav className="navbar navbar-expand-lg fixed-top">
        <div className="container">
            <a className="navbar-brand" href="#home" onClick={closeNavbar}>
                National Symposium on AI
            </a>
            <button 
            className="navbar-toggler px-1" 
            type="button" 
            onClick={() => setExpanded(!expanded)}
            aria-expanded={expanded}
            aria-label="Toggle navigation"
            >
                <span className="navbar-toggler-icon"></span>
            </button>
            <div id="navbarNav" className={`collapse navbar-collapse ${expanded ? 'show' : ''}`}>
                <ul className="navbar-nav ms-auto">
                    <li className="nav-item">
                    <a className="nav-link" href="#home" onClick={closeNavbar}>
                        {/* <i className="fas fa-home me-1"></i> */}
                        Home
                    </a>
                    </li>
                    <li className="nav-item">
                    <a className="nav-link" href="#topics" onClick={closeNavbar}>
                        {/* <i className="fas fa-lightbulb me-1"></i> */}
                        Topics
                    </a>
                    </li>
                    <li className="nav-item">
                    <a className="nav-link" href="#speakers" onClick={closeNavbar}>
                        {/* <i className="fas fa-info-circle me-1"></i> */}
                        Speakers
                    </a>
                    </li>
                    <li className="nav-item">
                    <a className="nav-link" href="#timeline" onClick={closeNavbar}>
                        {/* <i className="fas fa-calendar me-1"></i> */}
                        Timeline
                    </a>
                    </li>
                    <li className="nav-item">
                    <a className="nav-link" href="#venue" onClick={closeNavbar}>
                        Venue
                    </a>
                    </li>
                    <li className="nav-item">
                    <a className="nav-link" href="#programme-committee" onClick={closeNavbar}>
                        Committee
                    </a>
                    </li>
                    {/* <li className="nav-item">
                    <div className="ai-btn ai-btn-secondary text-[0.8rem] text-decoration-none px-3 py-2"
                    onClick={handleShow}
                    >
                        <i className="fas fa-user-plus me-2"></i>Register
                    </div>
                    </li> */}
                </ul>
            </div>
        </div>
        <RegisterModal
            show={showModal} 
            onHide={handleClose} 
        />
    </nav>
);
};

export default Header;